import React from 'react';
import './SLabel.css';

export interface SLabelProps {
  children: React.ReactNode;
  size?: number;
  weight?: number;
  color?: string;
  lineHeight?: number;
  className?: string;
  onClick?: () => void;
}

export const SLabel: React.FC<SLabelProps> = ({
  children,
  size = 15,
  weight = 700,
  color = 'var(--Text-action-black, #000)',
  lineHeight = 20,
  className = '',
  onClick,
}) => {
  const style: React.CSSProperties = {
    fontSize: `${size}px`,
    fontWeight: weight,
    color,
    lineHeight: `${lineHeight}px`,
    ...(onClick && { cursor: 'pointer' }),
  };

  return (
    <span
      className={`s-label ${className}`}
      style={style}
      onClick={onClick}
    >
      {children}
    </span>
  );
};

export default SLabel;
